module.exports = "/src/views/player/help/images/zoo.jpg";